import Box from '@mui/material/Box';
import { observer } from 'mobx-react-lite';
import {
  CheckboxField,
  TextField,
  Widget,
  WidgetProps,
} from '../../../../../components';
import Product from '../../../store/Product';

export default observer(function LicenseWidget({
  product,
  ...rest
}: { product: Product } & WidgetProps) {
  const { license } = product;

  return (
    <Widget surface="gray" title="License" {...rest}>
      <CheckboxField
        label="Enable licensing"
        name="enabled"
        onChange={license.handleChange}
        sx={{ mt: 0 }}
        value={license.enabled}
      />

      {license.enabled && (
        <Box
          sx={{
            alignItems: 'start',
            columnGap: 3,
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, 240px)',
            rowGap: 2,
          }}
        >
          <TextField
            errorText={license.errors.seatLimit}
            helperText="Machines per key at once"
            label="Seat limit"
            name="seatLimit"
            onBlur={license.handleBlur}
            onChange={license.handleChange}
            required
            type="number"
            value={license.seatLimit}
          />
          <TextField
            endAdornment="days"
            errorText={license.errors.onlineLeaseDays}
            helperText="Pulse renews it silently while online"
            label="Online lease"
            name="onlineLeaseDays"
            onBlur={license.handleBlur}
            onChange={license.handleChange}
            required
            type="number"
            value={license.onlineLeaseDays}
          />

          <CheckboxField
            label="Allow offline activation"
            name="offlineEnabled"
            onChange={license.handleChange}
            sx={{ gridColumn: 1, mt: 3 }}
            value={license.offlineEnabled}
          />
          {license.offlineEnabled && (
            <TextField
              endAdornment="days"
              errorText={license.errors.offlineLeaseDays}
              helperText="Then a new license file is needed"
              label="Offline lease"
              name="offlineLeaseDays"
              onBlur={license.handleBlur}
              onChange={license.handleChange}
              required
              type="number"
              value={license.offlineLeaseDays}
            />
          )}
        </Box>
      )}
    </Widget>
  );
});
